module.exports = __webpack_public_path__ + "static/media/master-real-estate.7584d2bc.svg";